export default class ClickAttacherService {
  constructor(dataLayerService, eventLocalNormalizer) {
    this.dataLayerService = dataLayerService;
    this.eventLocalNormalizer = eventLocalNormalizer;
  }

  attachEvents(eventsConfiguration) {
    eventsConfiguration.forEach(eventConfiguration => {
      const { hasMultipleElements } = eventConfiguration;

      if (hasMultipleElements) {
        this._setupEvents(eventConfiguration);

        return;
      }

      this._setupEvent(eventConfiguration);
    });
  }

  _setupEvents(eventConfiguration) {
    if (!eventConfiguration) return;

    const { selector } = eventConfiguration;

    const elements = document.querySelectorAll(selector);
    if (elements.length === 0) return;

    elements.forEach(element => {
      element.addEventListener('click', () => {
        this._buildClickEvent(eventConfiguration, element);
      });
    });
  }

  _setupEvent(eventConfiguration) {
    if (!eventConfiguration) return;

    const { selector } = eventConfiguration;

    const element = document.querySelector(selector);

    if (!element) return;

    element.addEventListener('click', () => {
      this._buildClickEvent(eventConfiguration, element);
    });
  }

  _buildClickEvent(eventConfiguration, element) {
    const { eventName, hasLocalByDOM, normalizer } = eventConfiguration;

    if (!hasLocalByDOM) {
      this.dataLayerService.addClickEvent({ event: eventName });

      return;
    }

    const local = this._getLocal(element, normalizer);

    this.dataLayerService.addClickEvent({
      event: `${eventName}_${local}`,
    });
  }

  _getLocal(element, normalizer) {
    return normalizer
      ? this.eventLocalNormalizer[normalizer](element)
      : element.innerText;
  }
}
